import { render, staticRenderFns } from "./CotacaoFreteDetalhes.vue?vue&type=template&id=839db566"
import script from "./CotacaoFreteDetalhes.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports